var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5C5.86316 2.5 2.5 5.86316 2.5 10C2.5 14.1368 5.86316 17.5 10 17.5C14.1368 17.5 17.5 14.1368 17.5 10C17.5 5.86316 14.1368 2.5 10 2.5ZM16.0632 10C16.0632 10.6947 15.9368 11.3737 15.7158 11.9895L10.7263 9.55789V3.98421C13.7263 4.34737 16.0632 6.90526 16.0632 10ZM10 16.0632C6.65263 16.0632 3.93684 13.3474 3.93684 10C3.93684 6.90526 6.27368 4.34737 9.27368 3.98421V10C9.27368 10.2684 9.43158 10.5211 9.68421 10.6474L15.0842 13.2842C14.0105 14.9579 12.1316 16.0632 10 16.0632Z",
    fill: "#737373",
    stroke: "#737373",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadIcon);
export default __webpack_public_path__ + "static/media/load-icon.d2c1b8f01e7aa3f6ce8694609b81b3ae.svg";
export { ForwardRef as ReactComponent };